<template>
	<v-img v-bind="$attrs" contain :src="imgSurvey">
		<slot></slot>
	</v-img>
</template>
<script>
import imgSurvey from '../../assets/img/survey-1.svg'
export default{
	data(){
		return { imgSurvey }
	}
}
</script>